import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authApi } from '../api';
import { useAuth } from '../context/AuthContext';

// AuthCallback: processes #session_id=... after Google OAuth redirect
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate('/');
      return;
    }

    (async () => {
      try {
        const res = await authApi.exchangeSession(sessionId);
        setUser(res.user);
        // clear hash and navigate to account
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/account', { replace: true });
      } catch (e) {
        navigate('/login-failed', { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FFF4E6] flex items-center justify-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full border-4 border-[#E63946] border-t-transparent animate-spin mx-auto" />
        <div className="font-display text-2xl uppercase mt-4">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
